import type { Dispatch, SetStateAction } from 'react';
import { useEffect, useState } from 'react';

export function useSyncedState<T>(
  sourceValue: T,
  initialValue: T,
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(sourceValue || initialValue);
  useEffect(() => {
    setValue(sourceValue);
  }, [sourceValue]);

  return [value, setValue];
}
